module.exports = __webpack_public_path__ + "static/media/Condominium.717d358d.png";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Wizard/parts/images/new/png-images/Condominium.png
// module id = 3040
// module chunks = 0